import { ApplicationState } from '@/redux/stores/types'

import { IAction } from '../actions/action-helpers'
import { RecentSearchesTypes } from '../actions/actions.types'

type RecentSearchesState = ApplicationState['recentSearches']

function recentSearchesReducer(state: RecentSearchesState = [], action: IAction): RecentSearchesState {
	switch (action.type) {
		case RecentSearchesTypes.GetRecentSearches.SUCCESS:
			return action.payload.searches || state
	}
	return state
}

export default recentSearchesReducer
